import Data from './Data';

const IframeSidebar = (props) => {
  return <Data {...props} />;
};

export default IframeSidebar;
